/**
 * @generated SignedSource<<6dafffab456bf5da3a87a9a9c15f5bb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type bznavRefundUserPhoneQuery$variables = Record<PropertyKey, never>;
export type bznavRefundUserPhoneQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly phone: string | null | undefined;
    };
  };
};
export type bznavRefundUserPhoneQuery = {
  response: bznavRefundUserPhoneQuery$data;
  variables: bznavRefundUserPhoneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BznavRefundOutput",
    "kind": "LinkedField",
    "name": "bznavRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefundUserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "bznavRefundUserPhoneQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "bznavRefundUserPhoneQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4ce4c7327347a8ef001cc11cccf40be7",
    "id": null,
    "metadata": {},
    "name": "bznavRefundUserPhoneQuery",
    "operationKind": "query",
    "text": "query bznavRefundUserPhoneQuery {\n  bznavRefund {\n    user {\n      phone\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59ecabc934a0755fe77ff2e9dbc04ee4";

export default node;
